import { Component, OnInit, Input } from "@angular/core";
import { ThemePalette } from "@angular/material/core";
import { DecimalPipe } from "@angular/common";
import { SummaryFigureValueType, SummaryFigureContext } from "../../../plan/_components/summary/summary-figure.model";

@Component({
    selector: "summary-figure-header",
    templateUrl: "./summary-figure-header.component.html",
    styleUrls: ["./summary-figure-header.component.scss"],
    standalone: false
})
export class SummaryFigureHeaderComponent implements OnInit {
	private __value = 0;
	@Input() set value(val: number) {
		this.__value = val;
		this.__updateValueStr();
	}

	_valueType: SummaryFigureValueType = "currency";
	@Input() set valueType(val: SummaryFigureValueType) {
		if (val) {
			this._valueType = val;
			this.__updateValueStr();
		}
	}

	private __valuePrecision = 0;
	@Input() set valuePrecision(val: number) {
		if (val) {
			this.__valuePrecision = val;
			this.__updateValueStr();
		}
	}

	private __currencySymbol = "$";
	@Input() set currencySymbol(val: string) {
		if (val) {
			this.__currencySymbol = val;
		}
	}

	__subText = "";
	@Input() set subText(val: string) {
		if (val) {
			this.__subText = val;
		}
	}

	__discountText = "";
	@Input() set discountText(val: string) {
		if (val) {
			this.__discountText = val;
		} else {
			this.__discountText = "";
		}
	}

	@Input() valueSuffix: string;
	@Input() hasEnergy: boolean;

	@Input() color: ThemePalette;
	@Input() colorOff = true;

	_flowType = "";
	@Input() set flowType(val: string) {
		if (val) {
			this._flowType = val;
		}
	}

	_symbol = "";
	_valueStr = "";

	@Input() set context(ctx: SummaryFigureContext) {
		if (ctx) {
			this.value = this.value || ctx.value;
			this.valueType = this.valueType || ctx.valueType;
			this.valuePrecision = this.valuePrecision || ctx.valuePrecision;
			this.valueSuffix = this.valueSuffix || ctx.valueSuffix;
			this.subText = this.subText || ctx.subText;
			this.discountText = this.discountText || ctx.discountText;
			this.color = this.color || ctx.color;
			this.colorOff = this.colorOff || ctx.colorOff;
		}
	}

	constructor(private __decimalPipe: DecimalPipe) {}

	ngOnInit() {
		this.__updateValueStr();
	}

	private __updateValueStr() {
		let digitFormat = "0.0-0";

		if (this._valueType !== "currency") {
			this._symbol = undefined;
			digitFormat = `0.${this.__valuePrecision}-${this.__valuePrecision}`;
		} else {
			this._symbol = this.__currencySymbol;
			if (this.hasEnergy) {
				if (this.__value % 1 === 0) {
					digitFormat = "1.0-0";
				} else {
					digitFormat = "0.2-2";
				}
			} else {
				digitFormat = Number.isInteger(this.__value) ? digitFormat : "0.2-2";
			}
		}

		this._valueStr = this.__decimalPipe.transform(
			this.__value,
			digitFormat
		);

		if (this._valueType === "percent") {
			this._valueStr = `+${this._valueStr}%`;
		}
	}
}
